import { DIMENSIONS, type Choice, type Dimension, type Scores } from "./types";

export const MIN_SCORE = 0;
export const MAX_SCORE = 10;
export const STARTING_SCORES: Scores = {
  warmth: 5,
  curiosity: 5,
  boundaries: 5,
  exitTiming: 5,
};

export function clampScore(value: number): number {
  return Math.min(MAX_SCORE, Math.max(MIN_SCORE, value));
}

export function applyChoice(scores: Scores, choice: Pick<Choice, "delta">): Scores {
  return DIMENSIONS.reduce<Scores>((next, dimension) => {
    next[dimension] = clampScore(scores[dimension] + (choice.delta[dimension] ?? 0));
    return next;
  }, { ...scores });
}

export function scoreLabel(score: number): string {
  if (score >= 8) return "glowing";
  if (score >= 6) return "steady";
  if (score >= 4) return "warming up";
  return "try another route";
}

export const DIMENSION_LABELS: Record<Dimension, string> = {
  warmth: "Warmth",
  curiosity: "Curiosity",
  boundaries: "Boundaries",
  exitTiming: "Exit timing",
};
